import React from "react";
import { IUsersProps } from "./users.types";
import DashboardMembersSettings from "./dashboardMembersSettings/dashboardMembersSettings";

export const UsersBase = (props: IUsersProps) => {
    return <><DashboardMembersSettings /></>
}